<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body">

        <el-row>
          <el-col :span="12" class="item">
            <div class="label">岗位目标量总分值</div>
            <el-input v-model="govInfo.targetValue"  placeholder="请输入目标量分值"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">岗位关键指标总分值</div>
            <el-input v-model="govInfo.keyValue"  placeholder="请输入关键指标分值"></el-input>
          </el-col>
        </el-row>

        <div style="padding: 20px 20px;color: gray;font-size: 12px;">
          <div>说明：</div>
          目标量分值+关键指标分值=100<br/>
        </div>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="saveChange()">保存</el-button>
      </div>

    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'ElderlyGov',
  data() {
    return {

      loading: false,

      name:'',

      govInfo:{},

      th:this.$store.state.tableHeight,
    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  methods: {
    init(obj){
      this.govInfo = obj;

    },
    closeSelf() {
      this.$emit("closeTargetKeyValue");
    },

    saveChange(){

      if((this.govInfo.targetValue-0)+(this.govInfo.keyValue-0) != 100){
        this.$message.info("目标量分值+关键指标分值=100分");
        return;
      }

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BaseSet/EditTargetKeyValue',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          targetValue:this.govInfo.targetValue,
          keyValue:this.govInfo.keyValue,
        }
      }).then( (response)=> {
        //console.log(response);

        this.loading = false;

        if(response.data.error == 0){
          this.$emit("closeTargetKeyValue");
          this.$emit("getGovInfo");

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });


    },


  }
}


</script>

<style lang="scss" scoped>

</style>
